// extracted by mini-css-extract-plugin
module.exports = {"flex":"forget_flex__1X1od"};